import { useCallback, useEffect, useMemo, useState } from "react";
import {
  Step,
  // StepDescription,
  StepIcon,
  StepIndicator,
  StepNumber,
  StepStatus,
  StepTitle,
  Stepper,
  useSteps,
  Box,
  StepSeparator,
  Center,
  BoxProps,
  Text,

  // Text,
} from "@chakra-ui/react";

import ClockGif from "assets/gif/clock.gif";
import { readableStatus } from "utils";

interface IProps extends BoxProps {
  transferStatus: string;
  paymentStatus: string;
  type: "buy" | "sell";
  reason?: string;
  coin: string;
}
const WidgetStatusStepper = ({ paymentStatus, coin, type, transferStatus, reason, ...props }: IProps) => {
  const title = type === "buy" ? `${coin} Delivered` : `${coin} Sent`;

  const stepOne = useCallback(() => ["Initiated", "Receiving", "Delivering"], []);
  const stepTwo = useCallback(() => ["Initiated", "Confirmed", "Delivering"], []);
  const stepThree = useCallback(() => ["Initated", "Confirmed", "Delivered"], []);

  const [steps, setSteps] = useState(stepOne);

  const { activeStep, setActiveStep, isCompleteStep } = useSteps({
    index: 1,
    count: steps.length,
  });

  useEffect(() => {
    if (
      (paymentStatus === "PaymentConfirmed" && transferStatus !== "TransferComplete") ||
      transferStatus === "TransferSendingCryptoFunds"
    ) {
      setActiveStep(2);
      setSteps(stepTwo);
    } else {
      setSteps(stepOne);
      setActiveStep(1);
    }
  }, [paymentStatus, stepOne, stepThree, stepTwo, title, transferStatus, setActiveStep]);

  const statusComp = useMemo(() => {
    let comp = null;
    if (transferStatus === "TransferComplete") {
      return (
        <Text color="#6FBE45" fontWeight="600">
          Transfer Completed
        </Text>
      );
    }

    if (["PaymentCancelled", "PaymentFailed", "PaymentIncomplete"].includes(paymentStatus)) {
      return (
        <Text color="#ED1C00" fontWeight="600">
          {readableStatus(paymentStatus) ?? "Payment Cancelled"}
        </Text>
      );
    }

    if (["TransferFailed", "TransferAmlFailed", "TransferCancelled"].includes(transferStatus)) {
      return (
        <>
          <Text color="#ED1C00" fontWeight="600">
            {readableStatus(transferStatus) ?? "Payment Cancelled"}
          </Text>

          {reason && (
            <Text pl="0px" fontSize="14px">
              <Text as="span" fontWeight="600">
                Reason:
              </Text>{" "}
              {reason}
            </Text>
          )}
        </>
      );
    }

    return comp;
  }, [transferStatus, paymentStatus, reason]);

  return (
    <Box pos="relative">
      <>
        {/* <Box>Payment --- {paymentStatus}</Box>
        <Box>Trasnfer --- {transferStatus}</Box> */}
        {statusComp || (
          <Stepper
            index={activeStep}
            orientation="horizontal"
            width="100%"
            gap="0 !important"
            colorScheme="primary"
            pos="relative"
            {...props}
          >
            {steps.map((title, index) => (
              <Step
                key={index}
                style={{
                  gap: "4px",
                }}
              >
                <Center flexDir="column" gap="4px">
                  <StepIndicator
                    gap="0 !important"
                    width="24px"
                    height="24px"
                    border={isCompleteStep(index) ? "none" : activeStep !== index ? "1px solid #C4C4C4" : "none"}
                  >
                    <StepStatus
                      complete={<StepIcon />}
                      key={index}
                      incomplete={<StepNumber />}
                      active={<img width="24px" height="24px" src={ClockGif} alt="hey" />}
                    />
                  </StepIndicator>

                  <Box flexShrink="0">
                    <StepTitle
                      style={{
                        fontSize: "14px",
                      }}
                    >
                      {title}
                    </StepTitle>
                  </Box>
                </Center>

                <StepSeparator
                  className="seperator"
                  style={{
                    background: activeStep === index ? "#C4C4C4" : "#3AC1A1",
                    margin: "-1.5rem -0.75rem 0 -0.75rem",
                  }}
                />
              </Step>
            ))}
          </Stepper>
        )}
      </>
    </Box>
  );
};

export default WidgetStatusStepper;
